export {
  // eslint-disable-next-line @fluentui/ban-context-export
  WindowContext,
  useWindow,
  useDocument,
  WindowProvider,
} from './WindowProvider';
export type { WindowProviderProps } from './WindowProvider';

import './version';
